import { TDOId } from '@common-modules/universal/models/Brands';
import { RUN_OCR_DEFAULT } from './ocrPreference';
export const namespace = 'vtn-redact-engine-ingestion';
export interface JobState {
  jobId?: string;
  isRunning: boolean;
  status:
    | 'pending'
    | 'queued'
    | 'running'
    | 'complete'
    | 'failed'
    | 'cancelled'
    | 'aborted';
  startedOn: Date;
  endedOn?: Date;
  error?: string;
}

export interface IngestionTDOs {
  [tdoId: TDOId]: {
    [jobId: string]: JobState;
  };
}

export interface IngestionStore {
  runHead: boolean;
  runPerson: boolean;
  runTranscription: boolean;
  /**
   * Speaker separation on ingest. Opt-in on its own: checking it checks
   * `runTranscription` too, since there is nothing to group without a
   * transcript, but transcribing does not opt you into separating.
   */
  runSpeakerSeparation: boolean;
  runVoiceMask: boolean;
  runPII: boolean;
  /**
   * Run the Redact Document OCR engine on ingested documents — independent of
   * `runPII`, so a document can be made searchable without PII detection.
   *
   * Unlike every other option here it starts TRUE and is remembered across
   * reloads; the FilePicker re-seeds it from `readRunOcrPreference()` each time
   * the dialog opens. See `ocrPreference.ts`.
   */
  runOCR: boolean;
  transcriptionLanguage: string;
  tdos: IngestionTDOs;
}

export const defaultState: IngestionStore = {
  runHead: false,
  runPerson: false,
  runTranscription: false,
  runSpeakerSeparation: false,
  runVoiceMask: false,
  runPII: false,
  // The stored preference wins over this the moment the dialog opens; this is
  // only what an upload path that never renders the dialog would get.
  runOCR: RUN_OCR_DEFAULT,
  transcriptionLanguage: 'en',
  tdos: {},
};

export const defaultJobSlice = (): JobState => ({
  jobId: undefined,
  isRunning: true,
  status: 'pending',
  startedOn: new Date(),
  endedOn: undefined,
  error: undefined,
});
